<template>
<v-card>
  <v-card-title>
    <v-flex xs11>
      <span style="font-size:16px">
        <b>
          {{ relatedValue.name }}
        </b>
      </span>
    </v-flex>
    <v-flex xs1>
      <v-icon v-if="editEnable" block color="green darken-2" fab small style="color: #efefef;"
              @click='$emit("edit",{})'>edit
      </v-icon>
    </v-flex>
  </v-card-title>
  <v-divider></v-divider>

  <v-list dens>
    <v-list-tile>
      <v-list-tile-content>{{$t('related.code')}}</v-list-tile-content>
      <v-list-tile-content class="align-end">{{ relatedValue.code }}</v-list-tile-content>
    </v-list-tile>
    <v-list-tile :key="index" v-for="(value,index) in relatedValue.values">
      <v-list-tile-content>{{ relatedSchema.keys[index].name }}:</v-list-tile-content>
      <v-list-tile-content class="align-end">{{ value.value }}</v-list-tile-content>
    </v-list-tile>
  </v-list>
  <v-divider></v-divider>
  <slot name="actions">
    <v-card-actions v-if="deleteEnabled" class="justify-center">
      <v-btn flat @click="$emit('delete', relatedValue)" color="orange">{{$t('related.delete')}}</v-btn>
    </v-card-actions>
  </slot>
</v-card>
</template>
<script>
import ValueEdit from "./ValueEdit"

export default {
  components: {
    ValueEdit
  },
  props: ['deleteEnabled', 'relatedValue', 'relatedSchema', 'editEnable'],
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  }
}
</script>

<style>
</style>
